import { ReactNode, HTMLAttributes } from 'react';
import cns from 'classnames';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { space, SpaceProps } from 'styled-system';

export const CONTAINER_CLASSNAME = '__mapui_container';

export interface ContainerProps
  extends HTMLAttributes<HTMLDivElement>,
    SpaceProps {
  children: ReactNode;
  className?: string;
  maxWidth?: 'xl' | 'lg' | 'md';
  disableXGutters?: boolean;
  yGutters?: boolean;
}

export const applyMainStyles =
  ({
    maxWidth: maxWidthProp,
    disableXGutters,
    yGutters,
  }: Pick<ContainerProps, 'maxWidth' | 'disableXGutters' | 'yGutters'>) =>
  (theme) => {
    const defaultStyle = css(theme.container.defaultStyles);
    const maxWidth = css({ maxWidth: theme.container.width[maxWidthProp] });

    const styles = [defaultStyle, maxWidth];

    if (yGutters) {
      styles.push(css(theme.container.paddingY));
    }

    if (!disableXGutters) {
      styles.push(css(theme.container.paddingX));
    }

    return css(...styles);
  };

export const Container = styled.div<ContainerProps>(
  ({ theme, maxWidth = 'xl', disableXGutters, yGutters }) => ({
    ...applyMainStyles({ maxWidth, disableXGutters, yGutters })(theme),
  }),
  ({ className }) => ({
    className: cns(CONTAINER_CLASSNAME, className),
  }),
  space
);
